module.exports = __webpack_public_path__ + "img/default-bigcover.69819fa1.jpg";